import { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import api from "../components/api"; // Ensure your API util is imported
import "./CuruChatsCategory.css";
import CuruChatsPost from "../components/CuruChatsPost";
import { FollowProvider } from "../context/FollowContext";

export default function CuruChatsCategory() {
  const location = useLocation();
  const category = location.state?.category;
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const [visibleCount, setVisibleCount] = useState(4);
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Fetch posts by category
    const fetchPosts = async () => {
      if (!category?.id) return;

      try {
        setIsLoading(true);
        const res = await api.get("/comunity/post", {
          params: { category: category.id },
        });
        setPosts(res.data || []);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPosts();
  }, [category]);

  if (!category) {
    return (
      <div className="category-error-container">
        <div className="category-error-message">
          <h1>Oops!</h1>
          <p>Sorry, an unexpected error has occurred.</p>
        </div>
        <Link to="/home-page" className="btn btn-primary text-white">
          Go Home
        </Link>
      </div>
    );
  }

  const handleProfileClick = (user) => {
    if (!user || !user.id) return;
    navigate(`/profile/${user.id}`, { state: { user } });
  };

  return (
    <>
      <div className="category-page-container">
        <FollowProvider>
          <div className="category-page-heading-container">
            <p className="directory-link">
              <Link to="/curu-chats">Curu Chats</Link>/ {category.name}
            </p>
            <p className="category-page-heading">{category.name}</p>
          </div>
          <div className="category-page-posts">
            {isLoading ? (
              <p>Loading posts...</p>
            ) : posts.length === 0 ? (
              <p>No posts found for this category.</p>
            ) : (
              <div className="category-posts-container">
                {posts.slice(0, visibleCount).map((post) => (
                  <CuruChatsPost
                    key={post.id}
                    post={post}
                    onProfileClick={handleProfileClick}
                    onDeleteSuccess={() =>
                      setPosts((prev) => prev.filter((p) => p.id !== post.id))
                    }
                  />
                ))}
                {visibleCount < posts.length && (
                  <div className="text-center my-4">
                    <button
                      className="submit-button"
                      onClick={() => setVisibleCount((prev) => prev + 4)}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </FollowProvider>
      </div>
    </>
  );
}
